<template>
  <section>
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-3">
            <img :src="avatar" class="custom-avatar1" />
          </div>
          <div class="col-md-9">
            <span class="custom-name">{{ name }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">{{ email }}</div>
          <div class="col-md-5">
            <span>cell #:</span><span class="ms-2">{{ phone }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <span>birthday:</span><span class="ms-2">{{ birthday }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12">
            {{ address1 }}
          </div>
          <div class="col-md-12">
            {{ address2 }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">{{ city }}</div>
          <div class="col-md-3">{{ state }}</div>
          <div class="col-md-3">{{ zipcode }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <span class="custom-id-code">#{{ id }}</span>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
export default {
  name: 'user-record',
  props: {
    recordData: Object,
  },
  mounted() {
    this.highlightUser()
  },
  computed: {
    ...mapGetters('users', ['user']),
    id() {
      let _data = null
      if (this.user) {
        _data = this.user.detail.id
      }
      return _data
    },
    email() {
      let _data = null
      if (this.user) {
        _data = this.user.detail.email
      }
      return _data
    },
    name() {
      let _data = null
      if (this.user) {
        _data = `${this.user.detail.lastName}, ${this.user.detail.firstName}`
        if (this.user.detail.nickName !== '') {
          _data += ` (${this.user.detail.nickName})`
        }
      }
      return _data
    },
    avatar() {
      let _data = null
      if (this.user) {
        _data = this.user.detail.avatar
      }
      return _data
    },
    phone() {
      let _data = null
      if (this.user) {
        _data = this.user.detail.phoneCell
      }
      return _data
    },
    birthday() {
      let _data = null
      if (this.user) {
        _data = moment(this.user.detail.birthday).format('MM/DD/YYYY')
      }
      return _data
    },
    address1() {
      let _data = null
      if (this.user) {
        _data = this.user.detail.address1
      }
      return _data
    },
    address2() {
      let _data = null
      if (this.user) {
        _data = this.user.detail.address2
      }
      return _data
    },
    city() {
      let _data = null
      if (this.user) {
        _data = this.user.detail.city
      }
      return _data
    },
    state() {
      let _data = null
      if (this.user) {
        _data = this.user.detail.state
      }
      return _data
    },
    zipcode() {
      let _data = null
      if (this.user) {
        _data = this.user.detail.zipcode
      }
      return _data
    },
  },
  methods: {
    ...mapActions('users', ['getUserHighlight']),
    async highlightUser() {
      await this.getUserHighlight(this.recordData.id)
      console.log('Got User (highlight)', this.user)
    },
  },
}
</script>
<style lang="scss">
.custom-name {
  font-size: 1.1em;
  font-weight: 500;
}
.custom-avatar1 {
  border-radius: 50%;
  width: 100px;
  height: 100px;
}
.custom-id-code {
  font-size: 0.8em;
}
</style>
